import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

// in case of update: remember to update also src/modules/prismic/utilities/index.ts for prismic-only pages (e.g. HOMEPAGE)
export const metaLinkBuilder = (route) => {
  const { url: currentUrl, storeCode } = currentStoreView()
  const { storeViews } = config
  // Cache exclusions for faster lookup
  const exclusions = new Set(
    (config.prismic.hreflangExclusions || []).map(locale =>
      locale.replace('_', '-').toLowerCase()
    ) || []
  )
  const hreflangs = []

  for (const locale of storeViews.mapStoreUrlsFor) {
    // Skip excluded locales
    if (exclusions.has(locale.replace('_', '-').toLowerCase())) {
      continue
    }
    const defaultLocale = storeViews[locale] && storeViews[locale].i18n && storeViews[locale].i18n.defaultLocale
    if (!defaultLocale) {
      continue
    }
    if (locale === 'int') {
      hreflangs.push({
        vmid: 'hreflang',
        rel: 'alternate',
        hreflang: 'x-default',
        href: config.client.url + route.fullPath.replace(currentUrl, '/int').replace(/\?page=1/, '')
      })
      continue
    }
    const formattedLocale = locale.includes('_')
      ? locale.replace('_', '-')
      : locale
    hreflangs.push({
      vmid: `hreflang-${formattedLocale}`,
      rel: 'alternate',
      hreflang: formattedLocale,
      href: (config.client.url + config.storeViews[locale].url + route.fullPath.replace(currentUrl, '')).replace(/\?page=1/, '')
    })
  }

  const routeName = route.name.replace(`${storeCode}-`, '')

  let canonicalHref = (config.client.url + route.path + (Object.keys(route.query).length ? '?' + Object.keys(route.query).map(key => key + '=' + route.query[key]).join('&') : ''))

  const urlObj = new URL(route.fullPath, config.client.url)
  urlObj.searchParams.delete('page')
  canonicalHref = urlObj.toString()

  return {
    title: routeName.charAt(0).toUpperCase() + routeName.slice(1),
    link: hreflangs.concat([
      {
        vmid: 'canonical',
        rel: 'canonical',
        href: canonicalHref
      }
    ])
  }
}
